import { render, staticRenderFns } from "./accuratepagetwo.vue?vue&type=template&id=c29c6be8&scoped=true"
import script from "./accuratepagetwo.vue?vue&type=script&lang=js"
export * from "./accuratepagetwo.vue?vue&type=script&lang=js"
import style0 from "./accuratepagetwo.vue?vue&type=style&index=0&id=c29c6be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29c6be8",
  null
  
)

export default component.exports